import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const LOGIN = "LOGIN";
const LOGOUT = "LOGOUT";
const ACCESS_MUTATION = 'access';

const getAccessFromLocalStorage = () => {
    try {
        const item = localStorage.getItem('access');
        return item ? JSON.parse(item) : {}
    } catch (e) {
        return {}
    }
}

export default new Vuex.Store({

    strict: process.env.NODE_ENV !== 'production',

    state: {
        isLoggedIn: !!localStorage.getItem("token") || localStorage.getItem("authProvider") === 'okta',
        access: getAccessFromLocalStorage(),
        isDemoUser: localStorage.getItem("isDemoUser") === 'true',
    },
    mutations: {
        [LOGIN] (state) {
            state.isLoggedIn = true;
        },
        [LOGOUT](state) {
            state.isLoggedIn = false;
        },
        [ACCESS_MUTATION](state, data) {
            state.access = data;
            // eslint-disable-next-line no-console
            console.log(state.access)
        },
        setDemoUser(state, value) {
            state.isDemoUser = !!value;
        }
    },

    actions: {


        login({ commit }, info) {

            localStorage.setItem("token", info[0]);
            localStorage.setItem("username", info[1]);
            localStorage.setItem("email", info[2]);
            localStorage.setItem("name", info[3]);
            localStorage.setItem("authProvider", "password");
            if(info[4]) {
                localStorage.setItem('access', JSON.stringify(info[4]))
            }
            localStorage.setItem("isDemoUser", "false");
            commit(ACCESS_MUTATION, info[4]);
            commit('setDemoUser', false);
            commit(LOGIN);


        },
        async loginOkta({ commit }) {
            localStorage.setItem("authProvider", "okta");
            commit(LOGIN);

            const { getAuthHeaders } = require('./_tools/auth-headers');
            const { env } = require('./_tools/env');
            const axios = require('axios').default;
            const baseURL = env('VUE_APP_BACKOFFICE_API', 'http://localhost:3033/');

            const res = await axios.get(`${baseURL}/api/admin/me`, {
                headers: await getAuthHeaders(),
            });

            const { username, access, isDemoUser } = res.data;
            localStorage.setItem("username", username);
            if (access) {
                localStorage.setItem('access', JSON.stringify(access));
            }
            localStorage.setItem("isDemoUser", isDemoUser ? "true" : "false");
            commit(ACCESS_MUTATION, access);
            commit('setDemoUser', isDemoUser);
        },
        async logout({ commit }) {
            const authProvider = localStorage.getItem("authProvider");
            localStorage.removeItem("token");
            localStorage.removeItem("username");
            localStorage.removeItem("email");
            localStorage.removeItem("name");
            localStorage.removeItem("authProvider");
            localStorage.removeItem("access");
            localStorage.removeItem("isDemoUser");

            if (authProvider === 'okta') {
                try {
                    const { getOktaAuth } = require('./okta/okta-auth');
                    const oktaAuth = getOktaAuth();
                    if (oktaAuth) {
                        await oktaAuth.revokeAccessToken();
                        oktaAuth.tokenManager.clear();
                        await oktaAuth.closeSession();
                    }
                } catch (e) {
                    console.error('Failed to sign out from Okta', e);
                }
            }

            commit(LOGOUT);
        }
    },

    getters: {
        isLoggedIn: state => {
            return state.isLoggedIn;
        },
        isCreateMerchantAccess: state => !!state.access.isAdministratorAccess,
        isUpdateMerchantAccess: state => !!state.access.isSuperUserAccess,
        isAddAccountAccess: state => !!state.access.isAdministratorAccess,
        isAddAggregatorMerchantAccess: state => !!state.access.isAdministratorAccess,
        isUpdateAccountAccess: state => !!state.access.isSuperUserAccess,
        isCreateGateAccess: state => !!state.access.isAdministratorAccess,
        isUpdateGateAccess: state => !!state.access.isAdministratorAccess,
        isShowGateSystemAccess: state => !!state.access.isSuperUserAccess,
        isShowAdminUsersAccess: state => !!state.access.isSuperUserAccess,
        isOnOffRampAccess: state => !!state.access.isAdministratorAccess,
        isAccountWithdrawalAccess: state => !!state.access.isAdministratorAccess,
        isTransactionRefundAccess: state => !!state.access.isAdministratorAccess,
        isShowLogsAccess: state => !!state.access.isAdministratorAccess,
        isAccuringAccess: state => !!state.access.isAdministratorAccess,
        isAccuringSystemAccess: state => !!state.access.isAdministratorAccess,
        isShowTransactionLogsAccess: state => !!state.access.isAdministratorAccess,
        isCreateBlackListAccess: state => !!state.access.isUserAccess,
        isUpdateBlackListAccess: state => !!state.access.isUserAccess,
        isCreateWhiteListAccess: state => !!state.access.isUserAccess,
        isUpdateWhiteListAccess: state => !!state.access.isUserAccess,
        isCreateMCCAccess: state => !!state.access.isSuperUserAccess,
        isDemoUser: state => !!state.isDemoUser,
        /*        isUserAccess: state => !!state.access.isUserAccess,
                isAdministratorAccess: state => !!state.access.isAdministratorAccess,
                isSuperUserAccess: state => !!state.access.isSuperUserAccess*/
    }

});
